import { Component, h, Method, State, Listen, Element, Prop, Host, Event, EventEmitter, Env } from "@stencil/core"
import { search, sendFeedback, checkStatus, getConfig } from "../../utils/utils"
// import InputForm from "./components/Form"
import SearchResult from "./components/SearchResult"

import { SocketService } from "../../utils/socket-service"
import { setCtaElement } from "../../utils/global-store"

@Component({
  tag: "ai12z-cta",
  styleUrls: ["./ai12z-cta.css", "../../global/tailwind.min.css"],
  shadow: true,
  // scoped: true
})
export class Ai12zCta {
  private dirty: boolean = false
  private isSubmitted = false
  private pButtonText: string = "Ask AI"
  private pPlaceholder: string = "AI search..."
  private pHelpText: string = "Enter text to get started"
  private pNoResultsText: string = "No results found"
  private errorMsg: string = "Error please try again!"
  private pheading: string = ""
  // private socket: any
  @State() socketService: SocketService

  @Prop({ mutable: true }) isCta: boolean = false
  @Prop({ reflect: true }) dataKey: string = Env.DATA_KEY || ""
  @Prop({ reflect: true }) dataMode: string = Env.DATA_MODE || "prod"
  @Prop({ reflect: true }) configId: string
  @Prop() dataAttributes: string
  @Prop() excludeTags: Array<string> = []
  @Prop() includeTags: Array<string> = []

  @State() ctaSettings: any = {}

  @Element() el!: HTMLElement
  @State() showModal: boolean = false
  @State() timer: any
  @State() questionCounter: number = 0
  @State() formData: { search: string; displayText: string } = { search: "", displayText: "" }
  @State() searchResults = []
  @State() error = null
  @State() conversationId = null
  @State() canRender = true
  @State() chatHistory = []
  @State() isChat = false
  @State() aiMessageId = null
  @State() thumbsId: string
  @State() imgFiles: any

  //#region Public onEvents
  @Event() errored: EventEmitter
  @Event() buttonClicked: EventEmitter
  @Event() messageSent: EventEmitter
  @Event() messageReceived: EventEmitter
  @Event() open: EventEmitter
  @Event() close: EventEmitter
  //#endregion

  @Event() stateChanged: EventEmitter
  @Event() clearResults: EventEmitter
  @Event() clearInput: EventEmitter
  @Event() stopStream: EventEmitter
  @Event() startStream: EventEmitter<{ search: string; maxQuestion?: boolean; chatData?: any; attributes?: any; imgFiles?: any }> // Add attributes to the type
  @Event() survey: EventEmitter
  @Event({
    eventName: "formSubmitted",
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  formSubmitted: EventEmitter<any>
  @Event({ composed: true, cancelable: true, bubbles: true }) streamResponse: EventEmitter<any>
  @Event({ composed: true, cancelable: true, bubbles: true }) endResponse: EventEmitter<any>

  private cdnPath: string = "https://cdn.ai12z.net/assets/bot"

  // @Watch("placeholder")
  // watchPlaceHolder(newValue: string, oldValue: string) {
  //   if (newValue === oldValue) {
  //     return
  //   }
  //   this.pPlaceholder = newValue
  // }

  @Method()
  async openModal() {
    this.showModal = true
    this.dirty = false
    // this.invokeSocket()
    if (this.ctaSettings?.clearMemory) {
      this.clearSearchHistory()
    }
    requestAnimationFrame(() => {
      const searchInput = this.el.shadowRoot.querySelector("ai12z-input-form").querySelector("textarea")
      searchInput.focus()
      this.el.shadowRoot.querySelector(".modal-wrapper").classList.add("show-modal")
      if (document.querySelector("ai12z-bot")) {
        const botEle = document.querySelector("ai12z-bot")
        botEle.shadowRoot.querySelector(".floating-icon")?.classList.add("hide-chatbot")
        botEle.shadowRoot.querySelector("bot-popover")?.classList.add("hide-chatbot")
      }
    })

    this.open.emit()
    this.setLocalData()
    // this.socketService = SocketService.createInstance(this.dataMode)
  }

  setLocalData() {
    const ctaData = { qCounter: this.questionCounter }
    localStorage.setItem(`ai12z-cta-data`, JSON.stringify(ctaData))
  }

  @Method()
  async sendMessage(message: string, displayText?: string) {
    this.formData.search = message
    this.formData.displayText = displayText ?? message
    this.handleSubmit(null, this.formData.search, "ask-ai", false, null)
    this.messageSent.emit(message)
  }

  @Method()
  async sendJSON(jsonData, displayText: string) {
    this.formData.search = JSON.stringify(jsonData)
    this.formData.displayText = displayText
    this.handleSubmit(null, this.formData.search, "ask-ai", false, null)
    this.messageSent.emit(jsonData)
  }

  @Method()
  async closeModal() {
    this.el.shadowRoot.querySelector(".modal-wrapper").classList.remove("show-modal")
    if (document.querySelector("ai12z-bot")) {
      const botEle = document.querySelector("ai12z-bot")
      botEle.shadowRoot.querySelector(".floating-icon")?.classList.remove("hide-chatbot")
      botEle.shadowRoot.querySelector("bot-popover")?.classList.remove("hide-chatbot")
    }
    setTimeout(() => {
      this.showModal = false
      this.stopStream.emit({ socketId: this.socketService?.getSocketId() })
      this.close.emit()
      clearInterval(this.timer)
    }, 300) // Assuming 300ms is your transition duration
  }

  @Listen("keydown", { target: "document" })
  handleKeyDown(ev: KeyboardEvent) {
    if (ev.metaKey && ev.key === "k") {
      this.openModal()
    }
    if (ev.key === "Escape") {
      this.ctaSettings?.allowClose ? this.closeModal() : ""
    }
  }

  @Listen("survey", { target: "document" })
  surveyHandler(_state) {
    //this.handleSubmit(null, _state.detail.results, _state.detail.type, false, null)
    if (_state.detail.type === "button") {
      this.formData.displayText = ""
      this.handleSubmit(null, _state.detail.results, _state.detail.type, false, null)
      this.buttonClicked.emit(_state.detail.results)
    } else if (_state.detail.type === "carousel") {
      this.chatHistory = [...this.chatHistory, _state.detail.results]
    } else if (_state.detail.type === "update") {
      const idx = this.chatHistory.findIndex(item => item.id === _state.detail.results.id)
      this.chatHistory = [...this.chatHistory.slice(0, idx), _state.detail.results, ...this.chatHistory.slice(idx + 1)]
    } else if (_state.detail.type === "sendMessage") {
      // console.log("sendMessage", _state.detail.results)
      if (_state.detail.results.length > 1) {
        this.sendMessage(_state.detail.results[0], _state.detail.results[1])
      } else {
        this.sendMessage(_state.detail.results[0])
      }
    } else if (_state.detail.type === "sendJSON") {
      this.sendJSON(_state.detail.results[0], _state.detail.results[1])
    } else {
      const surveyData = _state.detail
      const jsonData = `This JSON is from a form submission [${surveyData.keyName}]: ${JSON.stringify(surveyData.results, null, 2)}. There is no need to show the form [${surveyData.keyName}] again.`
      this.formData.search = jsonData
      this.formData.displayText = surveyData.completeText
      // console.log("surveyData", this.formData)
      this.handleSubmit(null, this.formData.search, "ask-ai", false, null)
      // this.sendSurveyData(_state.detail)
    }
  }

  @Listen("formComplete")
  formSubmittedHandler(event: CustomEvent) {
    event.stopPropagation()
    // console.log("Form submitted", event.detail)
    this.formSubmitted.emit(event.detail.data)
  }

  sendSurveyData = async surveyData => {
    // const query = "Here is the data you requested:" + surveyData.results
    // surveyData.domId = surveyData.domId.replace("surveyContainer-", "")
    // this.thumbsId = this.generateUUID()
    // this.aiMessageId = `ai-message-${this.generateUUID()}`
    const jsonData = "This JSON is from a form submission" + surveyData.results
    this.sendJSON(jsonData, surveyData.completeText)
    // const res = null
    // const res = await askAI(this.dataKey, this.dataMode, query, surveyData.conversationId, true, this.dataAttributes)
    // const idx = this.chatHistory.findIndex(item => item.id === surveyData.domId)

    // const lastMessage = {
    //   message: res?.answer,
    //   type: "ai",
    //   status: "success",
    //   insightId: res?.insight_id,
    //   formModel: res?.formModel,
    //   thumbsId: this.thumbsId,
    //   id: this.aiMessageId,
    // }

    // if (idx === -1) {
    //   // this.handleSubmit(null, query, "survey-res", false, null)
    //   this.chatHistory.splice(this.chatHistory.length - 1, 1)
    //   this.chatHistory = [...this.chatHistory, lastMessage]
    // } else {
    //   this.chatHistory = [...this.chatHistory.slice(0, idx), lastMessage, ...this.chatHistory.slice(idx + 1)]
    // }
    // this.startStream.emit({ search: query })
  }

  componentWillLoad() {
    // console.log("componentWillLoad ai12z-cta.tsx")
    // this.socket = this.socketService.getSocket()
    // this.socketService = SocketService.createInstance(this.dataMode)
    const slot = this.el["children"]
    let slotHasContent = slot && slot.length > 0
    this.detectTextByLang()
    if (slotHasContent) {
      for (var i = 0; i < slot.length; i++) {
        // console.log(slot[i].tagName.toLowerCase())
        if (slot[i].tagName.toLowerCase() === "cta" || slot[i].getAttribute("slot") === "cta") {
          this.isCta = true
        }
      }
    }
  }

  detectTextByLang = () => {
    let language =
      (navigator.languages && navigator.languages[0]) || // Chrome / Firefox
      navigator.language // All browsers

    let shortLang = language
    if (shortLang.indexOf("-") !== -1) shortLang = shortLang.split("-")[0]

    if (shortLang.indexOf("_") !== -1) shortLang = shortLang.split("_")[0]

    this.loadLanguageFile(shortLang)
      .then(data => {
        // console.log("data", data)
        // this.langData = data
        this.pButtonText = data.button_text
        this.pPlaceholder = data.placeholder_text

        this.pHelpText = data.help_text
        this.pNoResultsText = data.results_text
        this.errorMsg = data.error_message
      })
      .catch(error => {
        console.error("Error loading language file:", error)
      })
  }

  loadLanguageFile(langCode: string) {
    return import(/* @vite-ignore */ this.cdnPath + `/v1/lang/${langCode}.js`)
      .then(module => module.default)
      .catch(() => {
        return {} // Return an empty object or a fallback language data in case of an error
      })
  }

  clearSearchHistory() {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.splice(0, this.searchResults.length)
      this.searchResults = [...this.searchResults]
    }
    this.chatHistory = []
    this.isChat = false
    this.clearInput.emit(false)
    this.clearResults.emit(false)
  }

  handleOutsideClick(ev: MouseEvent) {
    const outsideContent = (ev.target as any).classList.contains("modal-wrapper")
    if (outsideContent) {
      this.ctaSettings?.allowClose ? this.closeModal() : ""
    }
  }

  generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }

  startTimer() {
    this.timer = setInterval(() => {
      this.questionCounter = 0
      // const endTime = Date.now()
      // console.log(`Timer executed after ${endTime} milliseconds`)
      localStorage.setItem(`ai12z-cta-data`, JSON.stringify({ qCounter: this.questionCounter }))
    }, this.ctaSettings?.autoResetTimer)
  }

  handleSubmit = async (event, value, type, followUp, imgFiles) => {
    if (type === "ask-ai") {
      this.questionCounter++
      localStorage.setItem(`ai12z-cta-data`, JSON.stringify({ qCounter: this.questionCounter }))
    }

    this.dirty = true
    this.isSubmitted = true
    event?.preventDefault()
    this.formData = { ...this.formData, search: value }

    if (this.chatHistory.length === 0 && this.ctaSettings?.autoResetTimer > 0 && type === "ask-ai") {
      this.startTimer()
    }

    if (!followUp && type === "follow-up") {
      this.chatHistory = []
      this.isChat = false
    }

    if (type === "survey") {
      this.chatHistory.splice(this.chatHistory.length - 1, 1)
    }

    if (!this.formData.search && this.formData.search?.length < 3 && imgFiles && imgFiles.length < 1) {
      this.isSubmitted = false
      this.stateChanged.emit(false)
      return
    }

    try {
      let response = { answer: "", formModel: null, insight_id: null }
      if (type === "ask-ai" || this.isChat) {
        if (this.chatHistory.length === 0) {
          this.socketService = SocketService.createInstance(this.dataMode)
        }
        this.isChat = true
        this.chatHistory.push({
          message: this.formData.displayText !== "" ? this.formData.displayText : this.formData.search,
          images: imgFiles,
          status: "success",
          type: "user",
        })
        this.aiMessageId = `ai-message-${this.generateUUID()}`
        this.thumbsId = this.generateUUID()
        this.chatHistory.push({
          message: `<div class="animate-ping">...</div>`,
          type: "ai",
          status: "pending",
          id: this.aiMessageId,
        })

        if (imgFiles && imgFiles.length > 0) {
          this.imgFiles = imgFiles
          //response = await askImgAI(this.dataKey, this.dataMode, imgFiles, this.formData.search)
        } else {
          this.imgFiles = [...[]]
          //  response = await askAI(this.dataKey, this.dataMode, this.formData.search, this.conversationId, followUp,this.dataAttributes)
        }

        //this.conversationId = response.conversation_id
        this.chatHistory.pop()
        response.answer = this.ctaSettings?.maxQuestion > 0 && this.questionCounter > this.ctaSettings?.maxQuestion ? this.ctaSettings.msgLimit : response?.answer
        //response.answer = response.answer.replace(RegExp(/\[[^>]*]/gm),'<div id="surveyContainer"></div>');
        const lastMessage = {
          message: response?.answer,
          type: "ai",
          status: "success",
          insightId: response?.insight_id,
          id: this.aiMessageId,
          thumbsId: this.thumbsId,
          formModel: response?.formModel,
        }

        this.chatHistory = [...this.chatHistory, lastMessage]
        // console.log("chatHistory")
        if (this.ctaSettings?.maxQuestion > 0 && this.questionCounter > this.ctaSettings?.maxQuestion) {
          console.log("Max question limit reached on cta")
          this.startStream.emit({ search: this.formData.search, maxQuestion: true, chatData: this.chatHistory[this.chatHistory.length - 1] })
        } else {
          console.log("type", typeof this.formData.search)
          this.startStream.emit({ search: this.formData.search, imgFiles: this.imgFiles })
        }
      } else {
        if (this.ctaSettings?.autoSearch) {
          response = await search(this.dataKey, this.dataMode, this.formData.search)
          this.displaySearchResults(response)
        }
      }
    } catch (error) {
      console.error(error)
      this.error = error
    } finally {
      this.isSubmitted = false
      this.stateChanged.emit(false)
      // this.formData.search = ""
      this.formData.displayText = ""
    }
  }

  displaySearchResults = results => {
    this.searchResults = results.docs
    this.isSubmitted = false
  }

  connectedCallback() {
    //this.parseMyObjectProp(this.myObject);
    checkStatus(this.dataKey, this.dataMode).then(enable => {
      this.canRender = enable
      // if (!enable) {
      //   console.log("ai12z canRender", this.canRender)
      // }
    })
    this.configCtaSettings()
  }

  configCtaSettings() {
    const payload = {
      apiKey: this.dataKey,
      configId: this.configId,
      configType: "search",
    }
    getConfig(payload, this.dataMode)
      .then(data => {
        // console.log("data", data)
        if (data) {
          // console.log("Web Settings", data)
          this.ctaSettings = data
          if (this.ctaSettings?.autoSearch === undefined) {
            this.ctaSettings.autoSearch = true
          }
          if (this.ctaSettings?.allowClose === undefined) {
            this.ctaSettings.allowClose = true
          }
          if (this.ctaSettings?.clearMemory === undefined) {
            this.ctaSettings.clearMemory = true
          }
          if (this.ctaSettings?.enableMobileView === undefined) {
            this.ctaSettings.enableMobileView = true
          }
          if (this.ctaSettings?.categorize === undefined) {
            this.ctaSettings.categorize = true
          }
          if (this.ctaSettings.customCSS) {
            this.insertCustomCSS(this.ctaSettings.customCSS)
          }
          if (this.ctaSettings.customJS) {
            const scriptEl = document.createElement("script")
            scriptEl.setAttribute("type", "text/javascript")
            scriptEl.setAttribute("src", this.ctaSettings.customJS)
            this.el.shadowRoot?.appendChild(scriptEl)
          }
        }
      })
      .catch(error => {
        console.log("error", error)
      })
  }

  insertCustomCSS(css: string) {
    console.log("css", css)
    const linkEl = document.createElement("link")
    linkEl.setAttribute("rel", "stylesheet")
    linkEl.setAttribute("href", css)

    const shadowRoot = this.el.shadowRoot
    if (shadowRoot) {
      shadowRoot.appendChild(linkEl)
    }
  }

  componentDidLoad() {
    setCtaElement(this.el)
    console.log("Component has been rendered")
  }

  // componentWillUpdate() {
  //   console.log("Component will update and re-render")
  // }

  defaultTemplate() {
    const isMac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent)
    return (
      <button type="button" class="flex ring-1  ring-slate-900/10 hover:ring-slate-300 focus:outline-none focus:ring-2 focus:ring-sky-500 shadow-sm custom-button">
        <svg
          width="24"
          height="24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="flex-none text-slate-300 dark:text-slate-400"
          aria-hidden="true"
        >
          <path d="m19 19-3.5-3.5"></path>
          <circle cx="11" cy="11" r="6"></circle>
        </svg>
        <span class="flex-auto">{this.pPlaceholder}</span>
        <kbd class="font-sans font-semibold text-slate-400">
          <abbr title="Command" class="no-underline text-slate-400">
            {isMac && <span>⌘</span>}
            {!isMac && (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="inline w-4 h-4 mb-1">
                <path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v2A1.5 1.5 0 0 0 3.5 7h2A1.5 1.5 0 0 0 7 5.5v-2A1.5 1.5 0 0 0 5.5 2h-2ZM3.5 9A1.5 1.5 0 0 0 2 10.5v2A1.5 1.5 0 0 0 3.5 14h2A1.5 1.5 0 0 0 7 12.5v-2A1.5 1.5 0 0 0 5.5 9h-2ZM9 3.5A1.5 1.5 0 0 1 10.5 2h2A1.5 1.5 0 0 1 14 3.5v2A1.5 1.5 0 0 1 12.5 7h-2A1.5 1.5 0 0 1 9 5.5v-2ZM10.5 9A1.5 1.5 0 0 0 9 10.5v2a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 12.5 9h-2Z" />
              </svg>
            )}
          </abbr>
          K
        </kbd>
      </button>
    )
  }

  displayMessage() {
    let message = null
    // let messageText = null
    if (this.error) {
      message = <p class="text-red-500">{this.errorMsg}</p>
    } else {
      if (this.isSubmitted) {
        message = (
          <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        )
      } else {
        if (this.dirty) {
          message = this.ctaSettings?.noResultsText ?? this.pNoResultsText
        }
        message = this.ctaSettings?.helpText ?? this.pHelpText
      }
    }
    if (this.searchResults?.length > 0 || this.chatHistory?.length > 0) {
      return null
    } else {
      if (typeof message === "string") {
        return <div class="flex prose custom-msg" innerHTML={message}></div>
      } else {
        return <p class="custom-msg flex">{message}</p>
      }
    }
  }

  render() {
    const style = {
      "width": this.ctaSettings?.enableMobileView ? "100%" : this.ctaSettings?.dialogWidth,
      "max-width": this.ctaSettings?.dialogMaxWidth,
    }
    if (!this.canRender) {
      return (
        <Host>
          <span style={{ display: "none" }}>Failed to load ai12z control due to insufficient fund</span>
        </Host>
      )
    }

    return (
      <Host>
        <div class="custom-container" onClick={() => this.openModal()}>
          {!this.isCta && this.defaultTemplate()}
          {this.isCta && <slot name="cta" />}
        </div>
        <div class={{ "bg-smoke-light": true, "hidden": !this.showModal, "modal-wrapper": true, "custom-model": true }} onClick={ev => this.handleOutsideClick(ev)}>
          <div class="overscroll-contain modal-content-wrapper model-content  modal-position" style={style}>
            <span class="btn-position">
              {this.ctaSettings?.allowClose && (
                <button onClick={() => this.closeModal()} class="modal-close">
                  &times;
                </button>
              )}
            </span>
            <h1 class="model-heading">{this.ctaSettings?.heading ?? this.pheading}</h1>
            <ai12z-input-form
              onAction={async event => {
                const { value, type, followUp, imgFiles } = event.detail
                await this.handleSubmit(event, value, type, followUp, imgFiles)
              }}
              isChat={this.isChat}
              placeholder={this.ctaSettings?.placeholder ?? this.pPlaceholder}
              buttonText={
                this.ctaSettings?.buttonText
                  ? this.ctaSettings?.buttonText
                  : this.ctaSettings?.buttonText == "" || !this.ctaSettings?.buttonText || (this.ctaSettings?.buttonText == "" && this.ctaSettings?.iconSrc == "")
                    ? !this.ctaSettings?.buttonText && this.ctaSettings?.iconSrc
                      ? ""
                      : this.pButtonText
                    : this.ctaSettings?.buttonText
              }
              iconSrc={this.ctaSettings?.iconSrc ?? ""}
              followUpLabel={this.ctaSettings?.followUpLabel ?? "Do you have a follow up question?"}
              isImageUpload={this.ctaSettings?.imageUpload ?? true} // Add the missing property here
              isEnableMic={this.ctaSettings?.enableMic ?? true} // Add the missing property here
            />
            {/* <InputForm isChat={this.isChat} placeholder={this.pPlaceholder} formData={this.formData} buttonText={this.pButtonText} onsubmit={this.handleSubmit} /> */}
            {this.displayMessage()}
            <div class="custom-results">
              {!this.isChat && !this.ctaSettings?.categorize && <SearchResult results={this.searchResults} />}
              {!this.isChat && this.ctaSettings?.categorize && <ai12z-category categoryList={this.searchResults} linkTarget={this.ctaSettings?.linkTarget}></ai12z-category>}
            </div>
            {this.isChat && (
              <ai12z-chat
                // socket={this.socket}
                chats={this.chatHistory}
                env={this.dataMode}
                query={this.formData.search}
                apiKey={this.dataKey}
                aiMessageId={this.aiMessageId}
                imgFiles={this.imgFiles}
                target={this.ctaSettings?.linkTarget === "" ? "_blank" : this.ctaSettings?.linkTarget}
                voiceType={this.ctaSettings?.audioType || "default"}
                voice={this.ctaSettings?.voice || "Google US English"}
                onFeedback={async event => {
                  const { feedback, insightId } = event.detail
                  sendFeedback(this.dataKey, this.dataMode, insightId, feedback)
                }}
                componentType="ctasearch"
                socketIn={this.socketService}
                dataAttributes={this.dataAttributes}
                chatExcludeTags={this.excludeTags}
                chatIncludeTags={this.includeTags}
                customstyle={this.ctaSettings?.customCSS}
                customJS={this.ctaSettings?.customJS}
              />
            )}
            {!this.isChat && (
              <div class="custom-privacy">
                <slot name="custom-privacy" />
              </div>
            )}
          </div>
        </div>
      </Host>
    )
  }
}
